var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",attrs:{"text":_vm.$i18n.locale.toUpperCase(),"exact":""}},_vm._l((_vm.activeLanguages),function(lang){return _c('b-dropdown-item',{key:lang.key,on:{"click":function($event){return _vm.setLang(lang.key)}}},[_c('div',{staticClass:"d-flex"},[_c('span',[_vm._v(" "+_vm._s(lang.key.toUpperCase()))])])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }